import React from 'react';
import { formatDefaultValueSelect } from '../../../../utils/mask';
import styles from './styles.module.scss';
import { Button } from "@mui/material";

export function ConsolidadoFilters({
                                       filtersSelectedValues,
                                       filterOptions,
                                       onUFChange = null,
                                       onMesChange = null,
                                       onAnoChange = null,
                                       onCanalChange = null,
                                       updateFilters = null
                                   }) {
    function handleUFChange({currentTarget}) {
        if (onUFChange) {
            const newValue = currentTarget.value;
            onUFChange(newValue);
        }
    }

    function handleMesChange({currentTarget}) {
        if (onMesChange) {
            const newValue = currentTarget.value;
            onMesChange(newValue);
        }
    }

    function handleAnoChange({currentTarget}) {
        if (onAnoChange) {
            const newValue = currentTarget.value;
            onAnoChange(newValue);
        }
    }

    function handleCanalChange({currentTarget}) {
        if (onCanalChange) {
            const newValue = currentTarget.value;
            onCanalChange(newValue);
        }
    }

    return (
        <div className={styles.big_container}>
            <div className={styles.content_consolidado}>
                {/* UF */}
                <div className={styles.uf_select}>
                    <div>
                        <label htmlFor="input-uf">UF</label>
                    </div>
                    <select
                        value={filtersSelectedValues?.uf ?? ''}
                        className="correct-color"
                        onChange={handleUFChange}
                    >
                        <option value={null}>Todas</option>
                        {filterOptions?.ufs &&
                            filterOptions?.ufs
                                .sort((a, b) => {
                                    return a?.sigla < b?.sigla ? -1 : a?.sigla > b?.sigla ? 1 : 0;
                                })
                                .map((uf) => (
                                    <option key={uf.id} value={uf.id} title={uf.sigla}>
                                        {uf.sigla}
                                    </option>
                                ))}
                    </select>
                </div>

                {/* mes */}
                <div className={styles.mes_select}>
                    <div>
                        <label htmlFor="input-mes">Mês</label>
                    </div>
                    <select
                        id="input-mes"
                        value={filtersSelectedValues?.mes ?? ''}
                        className="correct-color"
                        onChange={handleMesChange}
                    >
                        <option value={''}>Selecione</option>
                        {filterOptions?.meses &&
                            filterOptions?.meses.map((mes) => (
                                <option key={mes} value={mes}>
                                    {formatDefaultValueSelect(mes)}
                                </option>
                            ))}
                    </select>
                </div>

                {/* ano */}
                <div className={styles.ano_select}>
                    <div>
                        <label htmlFor="input-ano">Ano</label>
                    </div>
                    <select
                        className="correct-color"
                        value={filtersSelectedValues?.ano ?? ''}
                        onChange={handleAnoChange}
                    >
                        <option value={''}>Selecione</option>
                        {filterOptions?.anos &&
                            filterOptions?.anos.sort().map((ano) => (
                                <option key={ano} value={ano}>
                                    {ano}
                                </option>
                            ))}
                    </select>
                </div>
                <div className={styles.agente_select}>
                    <div>
                        <label htmlFor="input-canal">Agente</label>
                    </div>
                    <select
                        value={filtersSelectedValues?.atendente?.id ?? ''}
                        className="correct-color"
                        onChange={handleCanalChange}
                    >
                        <option value={null}>Todos</option>
                        { filterOptions?.atendentes?.map((at, idx) => (
                                <option key={idx} value={at.id}>
                                    {formatDefaultValueSelect(at.nome)}
                                </option>
                            ))}
                    </select>
                </div>
                {updateFilters && (
                    <div style={{marginTop: '13px'}}>
                        <Button onClick={updateFilters} variant="contained">
                            Filtrar
                        </Button>
                    </div>

                )}
            </div>
        </div>
    );
}
